import { render } from "./branchesAndStations.vue?vue&type=template&id=afc12f90"
import script from "./branchesAndStations.vue?vue&type=script&lang=js"
export * from "./branchesAndStations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__